import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CompanyService } from 'blg-akaun-ts-lib';
import { ViewColumnComponent } from '../../../../view-column.component';
import { AppConfig } from '../../../../visa';
import { SubSink } from 'subsink2';
import { SessionStates } from '../../../session/session-controller/states';
import { BranchSettingsStates } from '../../branch-settings-controller/states';
import { BranchSettingsActions } from '../../branch-settings-controller/actions';
import { BranchSettingsSelectors } from '../../branch-settings-controller/selectors';

@Component({
  selector: 'app-util-branch-details',
  templateUrl: './branch-details.component.html',
  styleUrls: ['./branch-details.component.scss']
})
export class UtilBranchDetailsComponent extends ViewColumnComponent {
  apiVisa = AppConfig.apiVisa;
  form: FormGroup;
  private subSink = new SubSink;
  branchGuid: string;
  showRounding: boolean = false;
  constructor(
    private sessionStore: Store<SessionStates>,
    private companyService: CompanyService,
    private store: Store<BranchSettingsStates>
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl(),
      code: new FormControl(),
      company : new FormControl(),
      salesAgent: new FormControl(''),
      rounding_five_cent: new FormControl(''),
      rounding_item_guid: new FormControl(''),
      group_discount_item_guid: new FormControl(''),
    })

    this.subSink.sink = this.store.select(BranchSettingsSelectors.selectBranch)
    .subscribe((b:any) => {
      this.branchGuid = b.guid;
      this.form.patchValue({
        name: b.name,
        description: b.descr,
        company:b.bl_fi_mst_comp_code,
        salesAgent:b.default_sales_entity_hdr_guid,
        code: b.code,
        rounding_five_cent: b.rounding_five_cent,
        rounding_item_guid: b.rounding_item_guid,
        group_discount_item_guid: b.group_discount_item_guid,
      });
      if( b.rounding_five_cent){
        this.showRounding = true;
      }
    })
  }

  enableRounding() {
    this.showRounding = !this.showRounding;
  }

  onSubmit(){
    this.store.dispatch(BranchSettingsActions.updateBranchDetails({guid: this.branchGuid, form: this.form}));
  }

  onReset(){
    this.form.patchValue({
      salesAgent: null,
      rounding_five_cent: null,
      rounding_item_guid: null,
      group_discount_item_guid: null
    })
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }
}
